// @TODO: convert more sectionlists to this component?
/**
 * Ryan O'Dowd
 * 2024-12-02
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import Header from './Header';
import {
  SectionList as RNSectionList,
} from 'react-native';
import React from 'react';
import getStyles from './styles';
import hooks from '@hooks';

const SectionList = (props: SectionListProps & React.ComponentProps<typeof SectionList>) => {
  const styles = hooks.useStyles(getStyles);

  return (
    <RNSectionList
      {...props}
      style={[styles.container, props.style]}
      contentContainerStyle={[styles.contentContainer, props.contentContainerStyle]}
      // @TODO: minor, but would be cool to add `marginTop: 4` to first element in list and `marginBottom: 4` to last one
      renderSectionHeader={props.renderSectionHeader || (({section: {title}}) => <Header>{title}</Header>)}
    />
  );
};

class SectionListProps {
  style?: any;
  contentContainerStyle?: any;
  renderSectionHeader?: ({section: {title}}) => any;
  // @TODO: any other prop that SectionList accepts from 'react-native'
};

export default SectionList;
